import gql from 'graphql-tag'

export const GET_ALL_TRAINERS = gql`
  query academyTrainers($schoolId: Int!, $limit: Int, $page: Int, $search: String) {
    academyTrainers(schoolId: $schoolId, limit: $limit, page: $page, search: $search) {
      meta {
        page
        limit
        total
      }
      data {
        id
        desc
        websiteUrl
        name
        email
        media {
          id
          url
        }
      }
    }
  }
`
